module.exports = __webpack_public_path__ + "img/logo.f3fb6fa8.png";